import { render, staticRenderFns } from "./SubmissionList.vue?vue&type=template&id=5b5e7403&scoped=true&"
import script from "./SubmissionList.vue?vue&type=script&lang=js&"
export * from "./SubmissionList.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionList.vue?vue&type=style&index=0&id=5b5e7403&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b5e7403",
  null
  
)

export default component.exports